import React from 'react';
import { Minus, Plus } from 'lucide-react';
import { motion } from 'framer-motion';

// Stepper for durations / rounds with large tap targets.
export const DurationStepper = ({
  label,
  value,
  onChange,
  step = 5,
  min = 0,
  max = 3600,
  suffix = 's',
  accent = '#38BDF8',
  testId,
}) => {
  const set = (v) => onChange(Math.max(min, Math.min(max, v)));
  return (
    <div className="flex flex-col gap-2" data-testid={testId}>
      {label && (
        <span className="text-xs font-semibold uppercase tracking-wider text-[#CBD5E1]">
          {label}
        </span>
      )}
      <div className="flex items-center justify-between rounded-2xl bg-white/5 p-2">
        <motion.button
          type="button"
          whileTap={{ scale: 0.9 }}
          onClick={() => set(value - step)}
          aria-label={`Decrease ${label}`}
          className="flex h-11 w-11 items-center justify-center rounded-xl bg-white/5 text-white hover:bg-white/10"
          data-testid={testId ? `${testId}-minus` : undefined}
        >
          <Minus size={18} />
        </motion.button>
        <span
          className="min-w-[64px] text-center text-2xl font-bold tabular-nums"
          style={{ color: accent }}
        >
          {value}
          <span className="ml-0.5 text-sm text-[#CBD5E1]">{suffix}</span>
        </span>
        <motion.button
          type="button"
          whileTap={{ scale: 0.9 }}
          onClick={() => set(value + step)}
          aria-label={`Increase ${label}`}
          className="flex h-11 w-11 items-center justify-center rounded-xl bg-white/5 text-white hover:bg-white/10"
          data-testid={testId ? `${testId}-plus` : undefined}
        >
          <Plus size={18} />
        </motion.button>
      </div>
    </div>
  );
};

export default DurationStepper;
